import React, { useState, useEffect } from 'react';
import { Wifi, WifiOff } from 'lucide-react';

interface ConnectionStatusProps {
  className?: string;
}

export const ConnectionStatus: React.FC<ConnectionStatusProps> = ({ className = '' }) => {
  const [isOnline, setIsOnline] = useState(true);

  useEffect(() => {
    const updateStatus = () => {
      setIsOnline(navigator.onLine);
    };

    window.addEventListener('online', updateStatus);
    window.addEventListener('offline', updateStatus);

    return () => {
      window.removeEventListener('online', updateStatus);
      window.removeEventListener('offline', updateStatus);
    };
  }, []);

  // Solo mostrar cuando está offline
  if (isOnline) {
    return null;
  }

  return (
    <div className={`fixed top-4 right-4 z-50 bg-red-500 text-white px-4 py-2 rounded-lg shadow-lg flex items-center space-x-2 ${className}`}>
      <WifiOff className="h-4 w-4" />
      <span className="text-sm font-medium">Sin conexión</span>
    </div>
  );
}; 